import "./DesignPath.module.css";
import Header from "@/reusable_sections/Header";
import Realization from "./sections/Realization";
import Transformation from "./sections/Transformation";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function DesignPathPage() {
  return <div>
      <Header />
      <Realization />
      <Transformation />
      <Faq />
      <Footer />
    </div>;
}